
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import { ModalSize } from '@/components/modal-size'

@Component<ConfirmDialog>({
    components: { Modal },
})
export default class ConfirmDialog extends Vue {
    @Prop({ type: String, default: '' }) public readonly title!: string
    @Prop({ type: String, default: '' }) public readonly message!: string
    @Prop({ type: String, default: 'Ok' }) public readonly okCaption!: string
    @Prop({ type: String, default: 'Cancel' })
    public readonly cancelCaption!: string
    @Prop({ type: String, default: '' })
    public readonly okClass!: string
    @Prop({ type: Boolean, default: false }) public readonly visible!: boolean
    @Prop({ type: Boolean, default: true }) public readonly vanilla!: boolean
    @Prop({ type: Boolean, default: true })
    public readonly allowClickOut!: boolean
    @Prop({ type: Boolean, default: true }) public readonly hasClose!: boolean
    @Prop({ type: String, default: ModalSize.Small })
    public readonly modalSize!: ModalSize

    public cancel() {
        this.$emit('cancel')
    }

    public ok() {
        this.$emit('ok')
    }
}
